import {shuffleArray} from '../../modules/dictionary/dictionaryUtils';

function generateDefaultInitialDictionaryState() {
  return {
    dictionaryArray: null,
    dictionaryDetail: null,
  };
}

function dictionaryReducer(state = generateDefaultInitialDictionaryState(), action) {
  let newState;

  switch (action.type) {
    case 'GET_DICTIONARY_INFO_FULFILLED': {
      const responseData = action.payload.response.data.data;
      newState = {
        ...state,
        dictionaryArray: shuffleArray(responseData),
      };
      break;
    }

    case 'GET_DICTIONARY_DETAIL_FULFILLED': {
      const responseData = action.payload.response.data.data;
      newState = {
        ...state,
        dictionaryDetail: responseData,
      };
      break;
    }

    case 'LEAVE_CATEGORY_PAGE_ROUTE': {
      newState = {
        ...generateDefaultInitialDictionaryState(),
      };

      break;
    }

    default:
      newState = state;
  }

  return newState;
}

export default dictionaryReducer;
export {generateDefaultInitialDictionaryState};
